import { handleException } from 'actions/exceptions';
import { ApiService } from '../../services';

export const GET_PDF_VIEW_REQUEST = 'GET_PDF_VIEW_REQUEST';
export const GET_PDF_VIEW_SUCCESS = 'GET_PDF_VIEW_SUCCESS';
export const GET_PDF_VIEW_FAILURE = 'GET_PDF_VIEW_FAILURE';

function requestGetPdfView() {
  return {
    type: GET_PDF_VIEW_REQUEST,
    isFetchingPdfView: true
  };
}

function receiveGetPdfView(viewPdfData) {
  return {
    type: GET_PDF_VIEW_SUCCESS,
    isFetchingPdfView: false,
    viewPdfData,
    getPdfViewError: null
  };
}

function rejectGetPdfView(getPdfViewError) {
  return {
    type: GET_PDF_VIEW_FAILURE,
    isFetchingPdfView: false,
    viewPdfData: null,
    getPdfViewError
  };
}

export function getPdfView(formId) {
  return (dispatch) => {
    dispatch(requestGetPdfView());

    const promise = () => ApiService
      .getPdfView(formId, { responseType: 'arraybuffer' })
      .then((response) => {
        dispatch(receiveGetPdfView(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          if (error.response) {
            error.response.data = { code: error.response.status, message: 'Sorry, we were unable to retrieve your form at this time, please come back later' };
          }
          dispatch(handleException(error, rejectGetPdfView));
        }
      });
    return promise();
  };
}
